[
    {
        "name": "Flange Tables",
        "tableList": [
            { "name": "tblAdditionalThickness" },
            { "name": "tblBoltMaterials" },
            { "name": "tblBoltMaterialSpecNo" },
            { "name": "tblBoltMaterialStandards" },
            { "name": "tblBoltMaterialValues" },
            { "name": "tblFlangeDimensions" },
            { "name": "tblFlangeDimensionsByFlangeType" },
            { "name": "tblFlangeFacingDimensionsByFlangeFacingType" },
            { "name": "tblFlangeFacingTypeLinks" },
            { "name": "tblFlangeFacingTypes" },
            { "name": "tblFlangeMaterials" },
            { "name": "tblFlangeMaterialSpecNo" },
            { "name": "tblFlangeMaterialStandards" },
            { "name": "tblFlangeMaterialThicknessValues" },
            { "name": "tblFlangeMaterialValues" },
            { "name": "tblFlangeTypes" },
            { "name": "tblGasketDimensions" },
            { "name": "tblGasketDimensionsRTJ" },
            { "name": "tblGasketDimensionValuesRTJ" },
            { "name": "tblGaskets" },
            { "name": "tblGasketTypes" },
            { "name": "tblGasketTypeStandards" },
            { "name": "tblGasketTypeWarning" },
            { "name": "tblJointTypes" },
            { "name": "tblMaterialGroupNumbers" },
            { "name": "tblPressureClasses" },
            { "name": "tblPressureTempRating" },
            { "name": "tblRingNumbers" },
            { "name": "tblTemperatureLoadLoss" },
            { "name": "tblTemperatureLoadLossGroup" }
        ]
    },
    {
        "name": "Clamp Tables",
        "tableList": [
            { "name": "tblClampMaterialHubMaterial" },
            { "name": "tblClampMaterials" },
            { "name": "tblClampPipeSizes" },
            { "name": "tblClamps" },
            { "name": "tblHubMaterial" },
            { "name": "tblHubs" },
            { "name": "tblSealRingHub" },
            { "name": "tblSealRingMaterialHubMaterial" },
            { "name": "tblSealRingMaterials" },
            { "name": "tblSealRings" }
        ]
    },
    {
        "name": "Bolt Load Group Tables",
        "tableList": [{ "name": "tblBoltLoadGroups" }, { "name": "tblBoltLoads" }, { "name": "tblBoltLoadValues" }, { "name": "tblTorqueRoundingStep" }]
    },
    {
        "name": "Common Tables",
        "tableList": [
            { "name": "tblBoltDimensions" },
            { "name": "tblDiagrams" },
            { "name": "tblLubricant" },
            { "name": "tblManufacturers" },
            { "name": "tblNutDimensionBoltDimension" },
            { "name": "tblNutDimensions" },
            { "name": "tblNutSplitters" },
            { "name": "tblPipeSchedules" },
            { "name": "tblPipeScheduleValues" },
            { "name": "tblPipeSizes" },
            { "name": "tblStandards" },
            { "name": "tblStandardsGroup" },
            { "name": "tblTensionerBoltDimensions" },
            { "name": "tblTensioners" },
            { "name": "tblTensionerSeries" },
            { "name": "tblTorqueWrenches" },
            { "name": "tblTorqueWrenchSeries" },
            { "name": "tblWasherDimensions" }
        ]
    }
]
